export const devicePhaseCode = {
  0: "1-Phase",
  1: "1-Phase",
  3: "3-Phase",
};

export const deviceStatusCode = {
  0: "NA",
  1: "ON",
  2: "OFF",
  3: "DIM",
};

export const lampStatusCode = {
  0: "NA",
  1: "Not Burning",
  2: "ILM No Comm",
};

export const serviceType = {
  0: "NA",
  1: "SC",
  2: "VC",
};

export const typeFilter = {
  0: "All",
  1: "With SLC",
  2: "Without SLC",
};

export const deviceModeCode = {
  0: "None",
  1: "Auto",
  2: "Manual",
  3: "Bypass",
  4: "Sunset",
  5: "Twilight",
};
export const poleType = {
  1: "C-Sec",
  2: "H-Sec",
  3: "I-Sec",
  4: "L-Sec",
  5: "Octagonal",
  6: "RCC New",
  7: "RCC Old",
  8: "Round",
  9: "Tubular",
};

export const deviceErrorEventCodeOrder = [
  5001,
  1001,
  1002,
  1003,
  1004,
  1005,
  1006,
  1007,
  1008,
  1009,
  1010,
  1011,
  2001,
  2002,
  2003,
  2004,
  2005,
  2006,
  2007,
  2008,
  2009,
  2010,
  2011,
  2012,
  2013,
  2014,
  2015,
  2016,
  2017,
  2018,
  2019,
  2020,
  3001,
];


export const deviceErrorEventCode = {
  5001: "No communication",
  1001: "Power Off",
  1002: "Low Battery",
  1003: "EMeter Comm Failure",
  1004: "Manual Mode",
  1005: "Bypass Mode",
  1006: "Door Open",
  1007: "Door Open Continuous",
  1008: "Lamp Off",
  1009: "Theft detected",
  1010: "Isolator off",
  1011: "Smps Fault",
  2001: "Input sense fail (R)",
  2002: "Input sense fail (Y)",
  2003: "Input sense fail (B)",
  2004: "MCB trip (R)",
  2005: "MCB trip (Y)",
  2006: "MCB trip (B)",
  2007: "Load sense fail (R)",
  2008: "Load sense fail (Y)",
  2009: "Load sense fail (B)",
  2010: "Low volt (R)",
  2011: "Low volt (Y)",
  2012: "Low volt (B)",
  2013: "High volt (R)",
  2014: "High volt (Y)",
  2015: "High volt (B)",
  2016: "High current (R)",
  2017: "High current (Y)",
  2018: "High current (B)",
  2019: "No load (R)",
  2020: "No load (Y)",

  3001: "Lamp Fail",
};

export const deviceErrorReportEventCode = {
  5001: "No Communication",
  3: "Power On",
  4: "Door Close",
  5: "Auto Mode",
  6: "Energy Meter Data",
  11: "Power Consumption Changed",
  17: "GSM Module Reset",
  18: "OS Reboot",
  100: "Load Off",
  101: "Load On",
  1001: "Power Off",
  1002: "Low Battery",
  1003: "Energy Meter Comm Failure",
  1004: "Manual Mode",
  1005: "Bypass Mode",
  1006: "Door Open",
  1007: "Door Open Continuous",
  1008: "Lamp Off",
  1009: "Theft",
  1010: "Isolator Off",
  1011: "Smps Fail",
  2001: "Input Sense Fail R",
  2002: "Input Sense Fail Y",
  2003: "Input Sense Fail B",
  2004: "Mcb Trip R",
  2005: "Mcb Trip Y",
  2006: "Mcb Trip B",
  2007: "Load Sense Fail R",
  2008: "Load Sense Fail Y",
  2009: "Load Sense Fail B",
  2010: "Under Volt R",
  2011: "Under Volt Y",
  2012: "Under Volt B",
  2013: "Over Volt R",
  2014: "Over Volt Y",
  2015: "Over Volt B"
}

export const deviceErrorCodes = {
  inputFaultList: [2010, 2011, 2012, 2013, 2014, 2015, 2001, 2002, 2003],
  outputFaultList: [2004, 2005, 2006, 2016, 2017, 2018, 2007, 2008, 2009],
};

export const panelApiKeyToLabelMap = {
  modes: {
    autoCnt: "Auto",
    manCnt: "Manual",
    // bypCnt: "Bypass",
  },
  inpFaults: {
    lvCnt: "Low Voltage",
    hvCnt: "High Voltage",
    pfCnt: "Power Failure",
    // isofCnt: "Isolator Fault"
  },
  outFaults: {
    tripCnt: "MCB Trip",
    hcCnt: "High Current",
    cfCnt: "Relay Failure",
  },
  othFaults: {
    emfCnt: "Energy Meter Comm. Failure",
    doCnt: "Door Open Continuously",
    lbCnt: "Low Battery",
    inaCnt: "No Communication",
  },
};

export const ticketStates = {
  1: "Assigned",
  2: "Resolved",
  3: "Reopened",
  4: "Closed"
};

export const ticketDeviceTypes = {
  0: "SLC",
  1: "LAMP",
  2: "ILM",
};
